import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from '@jajoga/auth-config/web';
import App from './App';
import './index.css';
// CRITICAL: import Amplify UI styles or login UI renders unstyled.
// (PITFALLS Pitfall 4 in 01-RESEARCH.md)
import '@aws-amplify/ui-react/styles.css';

Amplify.configure(amplifyConfig);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
